var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('portal',{attrs:{"to":"app-header"}},[_c('span',[_vm._v(_vm._s(_vm.$t('fileManager.title')))]),_c('v-btn',{staticClass:"ml-4 mb-1",attrs:{"icon":"","small":""}},[_c('v-icon',[_vm._v(" "+_vm._s('$info')+" ")])],1)],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }